// Environment detection based on webpack environment variables and window object
const isServer = process?.env?.IS_SERVER === 'true' || typeof window === 'undefined';
const isClient = !isServer;

export default isClient;
export {isServer, isClient};
